var map = {
	"./AboutIdiomaPage.json": 329,
	"./AskPage.json": 330,
	"./BlogPage.json": 331,
	"./Common.json": 332,
	"./ContactForm.json": 333,
	"./ContactInfo.json": 334,
	"./ContactUsPage.json": 335,
	"./CookieConsent.json": 166,
	"./CookiesConsent.json": 336,
	"./CrossCheckPage.json": 337,
	"./ErrorPage.json": 338,
	"./FaqPage.json": 339,
	"./HomePage.json": 340,
	"./ISyncPage.json": 341,
	"./IdiomaNmtPage.json": 342,
	"./IglossaryPage.json": 343,
	"./IndustriesPage.json": 344,
	"./LanguagesSupportedPage.json": 345,
	"./Navigation.json": 346,
	"./NewsPage.json": 347,
	"./NewsletterForm.json": 348,
	"./NextDocPage.json": 349,
	"./NmtPlusPePage.json": 350,
	"./OurHistoryPage.json": 351,
	"./OurOrganizationPage.json": 352,
	"./OurPhilosophyPage.json": 353,
	"./PrivacyPolicyConsent.json": 354,
	"./PrivacyPolicyPage.json": 355,
	"./ProjectManagementPage.json": 356,
	"./ResourcesPage.json": 357,
	"./ServicesPage.json": 358,
	"./StreamApiPage.json": 359,
	"./StreamPage.json": 360,
	"./TermsAndConditions.json": 361,
	"./TheFooter.json": 362,
	"./TheHeader.json": 363,
	"./TranslationInIQubePage.json": 364,
	"./WeAreIdiomaSection.json": 365
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1272;